import React, { useEffect } from 'react'
import useDimensions from 'react-use-dimensions'

export const withDimensions = (Component) => {
    return (props) => {
        const [ref, { width, height }] = useDimensions();

        useEffect(() => {
            // console.log(width, height);
        }, [width, height]);


        return (
            <div ref={ref}>
                <Component {...props} width={width} height={height} />
            </div>
        )
    }
}

// Get height from width where the aspect ratio 16:9
export function getHeightFromAspectRatio(width, aspectRatio = "16:9") {
    const [widthRatio, heightRatio] = aspectRatio.split(":");
    return width * (parseInt(heightRatio) / parseInt(widthRatio));
}

export function debounce(func, wait, immediate) {
    var timeout;

    return function executedFunction() {
        var context = this;
        var args = arguments;

        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait);

        if (callNow) func.apply(context, args);
    };
};


export function canvasResize(canvas, mainWidth = 525, containerId) {
    var canvasSizer = document.getElementById(containerId);
    var canvasScaleFactor = mainWidth / canvasSizer.offsetWidth;
    var width = canvasSizer.offsetWidth;
    var height = canvasSizer.offsetHeight;
    var ratio = canvas.getWidth() / canvas.getHeight();
    if ((width / height) > ratio) {
        width = height * ratio;
    } else {
        height = width / ratio;
    }
    var scale = width / canvas.getWidth();
    var zoom = canvas.getZoom();
    zoom *= scale;
    canvas.setDimensions({ width: width, height: height });
    canvas.setViewportTransform([zoom, 0, 0, zoom, 0, 0]);
    canvas.renderAll();
    console.log(canvasScaleFactor, canvasSizer.offsetWidth, mainWidth);
    
}

